const INITIAL_STATE = {
  map: null,
  center: {
    lat: null, 
    lng: null
  },
  zoom: window.innerWidth <= 800 ? 11 : 12, 
  markers: {
    user: null,
    queue: {
      venues: new Map(),
      performances: new Map() 
    },
    clickedMarkerData: {}
  },
  infoWindow: null,
  isProgrammaticPan: false
}


// Helper function to merge new markers into existing queue
const mergeMarkerQueue = (existingQueue, newItems) => {
  return new Map([...existingQueue.entries(), ...newItems.map(item => [item.id, item])])
}


const mapReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_MAP':
      return {
        ...state, 
        map: action.payload
      }
    case 'PAN_TO':
      return {
        ...state, 
        center: action.payload.center,
        isProgrammaticPan: action.payload.isProgrammaticPan
      }
    case 'UPDATE_ZOOM':
      return {
        ...state,
        zoom: action.payload
      }
    case 'SET_USER_MARKER':
      return {
        ...state,
        markers: {
          ...state.markers,
          user: action.payload
        }
      }
    case 'SET_CLICKED_MARKER_DATA':
      return { 
        ...state,
        markers: {
          ...state.markers,
          clickedMarkerData: action.payload
        }
      }
    case 'RESET_CLICKED_MARKER_DATA':
      return { 
        ...state,
        markers: {
          ...state.markers,
          clickedMarkerData: {}
        }
      }
    // ------------------------------------------------------------
    // The below deals with the marker queue, which represents
    // the markers that need to be added to the map
    // ------------------------------------------------------------
    case 'CREATE_PERFORMANCE_MAP_MARKER_QUEUE':
      return {
        ...state,
        markers: {
          ...state.markers,
          queue: {
            ...state.markers.queue,
            performances: new Map(action.payload.data.map(item => [item.id, item]))
          }
        }
      }
    case 'CREATE_VENUE_MAP_MARKER_QUEUE':
      return {
        ...state,
        markers: {
          ...state.markers,
          queue: {
            ...state.markers.queue,
            venues: new Map(action.payload.data.map(item => [item.id, item]))
          }
        }
      }
    case 'ADD_TO_PERFORMANCE_MAP_MARKER_QUEUE': 
      return {
        ...state,
        markers: {
          ...state.markers,
          queue: {
            ...state.markers.queue,
            performances: mergeMarkerQueue(state.markers.queue.performances, action.payload.data)
          }
        }
      }
    case 'ADD_TO_VENUE_MAP_MARKER_QUEUE':
      return {
        ...state,
        markers: {
          ...state.markers,
          queue: {
            ...state.markers.queue,
            venues: mergeMarkerQueue(state.markers.queue.venues, action.payload.data)
          }
        }
      }
    case 'RESET_PROGRAMMATIC_PAN':
      return {
        ...state,
        isProgrammaticPan: false
      }
    case 'SAVE_INFO_WINDOW':
      return {
        ...state,
        infoWindow: action.payload
      }
    default:
      return state
  }
}

export default mapReducer


